// Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, ExternalLink } from "lucide-react";
import logo from "../assets/black_logo.png";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-800 py-12 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Contact Us Column */}
          <div>
            <img
              src={logo}
              alt="San Diego Compassionate Caregivers"
              className="h-12 mb-6"
            />

            <h3 className="text-xl font-bold text-gray-900 mb-4">Contact Us</h3>

            <div className="space-y-3 text-sm">
              <div>
                <p className="font-semibold text-gray-900">Address:</p>
                <p>Cnr Mirrool & Stinson St,</p>
                <p>Coolamon NSW 2701,</p>
                <p>Australia</p>
              </div>

              <div>
                <a
                  href="tel:+61269272706"
                  className="text-[#E85D2C] hover:underline font-semibold"
                >
                  (02) 6927 2706
                </a>
              </div>

              <div>
                <a
                  href="#"
                  className="text-[#E85D2C] hover:underline font-semibold flex items-center gap-1"
                >
                  Directions
                  <ExternalLink size={14} />
                </a>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.facebook.com/allawahlodgeau"
                className="text-gray-600 hover:text-[#E85D2C] transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.facebook.com/allawahlodgeau"
                className="text-gray-600 hover:text-[#E85D2C] transition-colors"
              >
                <Instagram size={20} />
              </a>
              {/* <a href="#" className="text-gray-600 hover:text-[#E85D2C] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-[#E85D2C] transition-colors">
                <ExternalLink size={20} />
              </a> */}
            </div>
          </div>

          {/* Helpful Links Column */}
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Helpful Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/about/reviews-testimonials"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Testimonials
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Home Care Services Column */}
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Home Care Services
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/services/alzheimers-dementia-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Alzheimer's and Dementia Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/companionship-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Companionship Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/hospice-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Hospice Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/personal-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Personal Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/post-operative-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Post-Operative Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/respite-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Respite Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/specialty-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Specialty Care
                </Link>
              </li>
              <li>
                <Link
                  to="/services/spinal-cord-injury-care"
                  className="text-gray-700 hover:text-[#E85D2C] transition-colors"
                >
                  Spinal Cord Injury Care
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
